<template>
  <custom-tab
    content-class="mt-3"
    nav-class="nav-vue-underline"
    no-nav-style
    @input="onChangeTab"
  >
    <custom-tab-item title="Información de Orden y Equipo">
      <div v-if="hasOrderEquipmentInfo" class="px-md-3">
        <div class="mt-4">
          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-info-circle mr-2 text-orange"></i>
            <div class="color-gray-7 font-16 font-weight-bold">
              Datos de Equipo
            </div>
          </div>
          <div class="ml-4">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <span class="data-title">Descripción:</span>
                <p>{{ orderAndEquipmentInfo.equipment.description | empty }}</p>
              </div>
              <div class="col-lg-3 col-md-6 col-12">
                <span class="data-title">Cantidad:</span>
                <p>{{ orderAndEquipmentInfo.equipment.quantity | empty }}</p>
              </div>
              <div class="col">
                <span class="data-title">Precio:</span>
                <p>
                  {{ orderAndEquipmentInfo.equipment.price | price }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-2">
            <i class="circle-money mr-2 text-orange"></i>
            <div class="color-gray-7 font-16 font-weight-bold">
              Requisición y Cotización
            </div>
          </div>
          <div class="ml-4">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-12">
                <span class="data-title">Fecha de requisición:</span>
                <p>
                  {{
                    orderAndEquipmentInfo.requisitionQuote.requisitionDate
                      | date
                      | empty
                  }}
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-12">
                <span class="data-title">Fecha de RFQ:</span>
                <p>
                  {{
                    orderAndEquipmentInfo.requisitionQuote.rfqDate
                      | date
                      | empty
                  }}
                </p>
              </div>
              <div class="col">
                <span class="data-title">Número de RFQ:</span>
                <p>
                  {{ orderAndEquipmentInfo.requisitionQuote.rfqNumber | empty }}
                </p>
              </div>
              <div class="col">
                <span class="data-title">Tipo de Cifra:</span>
                <p>
                  {{
                    orderAndEquipmentInfo.requisitionQuote.isFederal
                      ? 'Federal'
                      : orderAndEquipmentInfo.requisitionQuote.isFederal ==
                        false
                      ? 'Estatal'
                      : '-'
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-2">
            <i class="file-icon  text-orange"></i>
            <div class="color-gray-7 font-16 font-weight-bold">
              Orden de Compra
            </div>
          </div>
          <div class="ml-4">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-12">
                <span class="data-title">Fecha de PO:</span>
                <p>
                  {{
                    orderAndEquipmentInfo.purchaseOrder.poDate | date | empty
                  }}
                </p>
              </div>
              <div class="col">
                <span class="data-title">Suplidor:</span>
                <p>
                  {{ orderAndEquipmentInfo.purchaseOrder.supplier | empty }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-2">
            <i class="calendar-icon mr-2 text-orange"></i>
            <div class="color-gray-7 font-16 font-weight-bold">CSEE</div>
          </div>
          <div class="ml-4">
            <span class="data-title">Fecha de Recibido CSEE:</span>
            <p>{{ orderAndEquipmentInfo.csee.receivedDate | date | empty }}</p>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center mb-2">
            <i class="school-icon mr-2 text-orange"></i>
            <div class="color-gray-7 font-16 font-weight-bold">Escuela</div>
          </div>
          <div class="ml-4">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-12">
                <span class="data-title">Fecha de Entrega Escuela:</span>
                <p>
                  {{ orderAndEquipmentInfo.school.deliveryDate | date | empty }}
                </p>
              </div>
              <div class="col">
                <span class="data-title">Fecha Discusión Escuela:</span>
                <p>
                  {{
                    orderAndEquipmentInfo.school.discussionDate | date | empty
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </custom-tab-item>
    <custom-tab-item title="Historial de Estatus">
      <div class="bg-white rounded mt-1 px-4 py-2">
        <custom-history :items="statusLog" />
      </div>
    </custom-tab-item>
    <custom-tab-item title="Historial de Bitácora">
      <div class="bg-white rounded mt-1 px-4 py-2">
        <binnacle-history :history="binnacle.history" />
      </div>
    </custom-tab-item>
  </custom-tab>
</template>

<script>
import { CustomTab, CustomTabItem } from 'custom-tabs';
import equipmentService from '@/services/api/referralsandequipments.api';
import peiAtEquipmentTabs from '@/utils/constants/peiAtEquipmentTabs';
import CustomHistory from '@quisit/mipe-custom-history';
import BinnacleHistory from './components/BinnacleHistory.vue';

export default {
  name: 'EquipmentTabs',
  components: {
    CustomTab,
    CustomTabItem,
    CustomHistory,
    BinnacleHistory,
  },
  props: {
    equipment: {
      type: Object,
      required: true,
    },
    tabIndex: {
      type: Number,
      default: peiAtEquipmentTabs.OrderAndEquipmentInfo,
    },
  },
  data() {
    return {
      orderAndEquipmentInfo: {},
      statusLog: [],
      binnacle: {
        history: [],
      },
    };
  },
  computed: {
    hasOrderEquipmentInfo() {
      return Boolean(Object.keys(this.orderAndEquipmentInfo).length);
    },
  },
  methods: {
    async getOrderAndEquipmentInfo() {
      if (this.hasOrderEquipmentInfo) return;
      const id = this.equipment.id;
      const { data } = await equipmentService.getOrderAndEquipmentInfo(id);
      this.orderAndEquipmentInfo = data;
    },
    onChangeTab(key) {
      this.$emit('onTabChanged', key);
      switch (key) {
        case peiAtEquipmentTabs.OrderAndEquipmentInfo:
          this.getOrderAndEquipmentInfo();
          break;
        case peiAtEquipmentTabs.StatusHistory:
          this.getStatusLog();
          break;
        case peiAtEquipmentTabs.LogHistory:
          this.handlerLoadBinacle();
          break;
        default:
          break;
      }
    },
    async getStatusLog() {
      const id = this.equipment.id;
      const { data } = await equipmentService.getEquipmentStatusLog(id);
      this.statusLog = data;
    },
    async handlerLoadBinacle() {
      const payload = {
        peiAtEquipmentId: this.equipment.id,
        peiAtEquipmentClassificationId: this.equipment
          .peiAtEquipmentClassificationId,
      };
      const { data } = await equipmentService
        .getEquipmentBinnacles(payload)
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
      if (data) {
        this.binnacle.history = data;
      }
    },
  },
};
</script>

<style lang="scss">
.circle-money {
  background-image: url('../../../assets/icons/circle-money.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: 14px;
  margin: -8px;
  margin-right: -2px !important;
}
.file-icon {
  background-image: url('../../../assets/icons/file.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: 8px;
  margin: -1px;
  margin-right: 4px !important;
}
.calendar-icon {
  background-image: url('../../../assets/icons/calendar-range.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: 7px;
  margin: -1px;
  margin-right: 5px !important;
}
.school-icon {
  background-image: url('../../../assets/icons/school.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  padding: 8px;
  margin: -1px;
  margin-right: 5px !important;
}
</style>
